import { post, postData } from './http'
import global from '@/api/global'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }

var name = global.signature
// 参数管理
export const aParAdd = p => post(`/${name}/parameter/add`, p)
export const aParupdate = p => post(`/${name}/parameter/update`, p)
export const aParlist = p => post(`/${name}/parameter/list`, p)
export const aParmDelete = p => post(`/${name}/parameter/suspension`, p)
export const aParmDel = p => post(`/${name}/parameter/aParmDel`, p)
// 参数管理检查密码
export const aParcheckPwd = p => post(`/${name}/parameter/checkPwd`, p)

// 区域管理
export const getTreeList = p => post(`/${name}/region/listTree`, p)
export const addRegion = p => post(`/${name}/region/add`, p)
export const updateRegion = p => post(`/${name}/region/update`, p)
export const regionSuspension = p => post(`/${name}/region/suspension`, p)
export const deleteRegion = p => post(`/${name}/region/deleteRegion`, p)

export const getRegionById = p => post(`/${name}/region/getRegionById`, p)

// 设备管理
export const aDevicelist = p => post(`/${name}/device/list`, p)
export const aDeviceClose = p => post(`/${name}/device/suspension`, p)
export const aDeviceDel = p => post(`/${name}/device/deviceDel`, p)
export const aDeviceAdd = p => post(`/${name}/device/add`, p)
export const aDeviceupdate = p => post(`/${name}/device/update`, p)

// 测试接口
export const aParlistToken = p => post(`/${name}/deviceExternal/kitToken`, p)
// 获取设备
export const getListByRegionId = p => post(`/${name}/deviceExternal/getListByRegionIddevice/list`, p)

// 视频改版20250623https://club.ys7.com/portal.php?mod=view&aid=90
// 设备列表
export const equipmentList = p => post(`/${name}/device/equipmentList`, p)
export const getVideoUrl = p => post(`/${name}/video/getVideoUrl`, p)// 获取视频流
